var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maskCon"},[_c('div',{staticClass:"content1"},[_c('el-carousel',{staticClass:"content1",attrs:{"indicator-position":"none","loop":false,"interval":_vm.interval},on:{"change":_vm.indexChange}},_vm._l((_vm.imgList),function(item){return _c('el-carousel-item',{staticClass:"outQ"},[_c('img',{attrs:{"src":item}})])}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }